<template>
	<div v-loading="loading" class="min_he400">
		<div class="site_zi" v-for="(item,i) in invoiceList" :key="item.id">
			<div v-show="isDisabled" class="flo_right site_tabs">
				<span v-if="item.is_default != 1" class="lan" @click="Postaddresssetdefault(item.id)">设为默认地址</span><br>
				<span class="lan" @click="setDizhi(item)">修改地址</span>
				<span class="lan red " @click="Postaddressdel(item.id)">删除地址</span>
	 	 	</div>
			<div class="site_title">
				<span>开具发票{{i+1}}</span>
				<span class="lan" v-if="item.is_default == 1">默认发票信息</span>
			</div>
			<div class="site_form clearfloat">
				<div class="form_left">专票/普通:</div>
				<div class=" che">
					 <el-radio-group v-model="item.type" :disabled="item.isDisabled" >
						<el-radio :label="1">专票</el-radio>
  						<el-radio :label="2">普票</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="site_form clearfloat">
				<div class="form_left">发票抬头:</div>
				<div class="form_right">
					<el-autocomplete :disabled="item.isDisabled" style="width:100%"  class="inline-input" v-model="item.look" clearable :fetch-suggestions="querySearch" 
					placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="(e)=>{item.look=e.name;item.identify_number=e.taxpayer_number}" >
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</div>
			</div>
			<div class="site_form clearfloat">
				<div class="form_left">纳税人识别号:</div>
				<div class="form_right">
					<el-input :disabled="item.isDisabled" v-model="item.identify_number" clearable></el-input>
				</div>
			</div>
			<div class="site_form clearfloat" v-if="item.type==1">
				<div class="form_left">专票信息（普票无需填写）:</div>
				<div class="form_right">
					 <el-input :disabled="item.isDisabled" :rows="3" :autosize="{ minRows: 2, maxRows: 5}" type="textarea" v-model="item.info"></el-input>
				</div>
			</div>
			<div v-show="!item.isDisabled" class="site_form clearfloat">
				<div class="form_left"></div>
				<div class="form_right">
					<el-button type="primary" @click="Postaddressupdate(item);">确 定</el-button>
					<el-button @click="quxiao(i)">取 消</el-button>
				</div>
			</div>
		</div>
		<div class="laing_btn " @click="dialogVisible = true">+新增发票信息</div>
		<!-- 添加发票信息 -->
		<el-dialog title="发票信息" :visible.sync="dialogVisible" width="600px" :before-close="closeform" :close-on-click-modal="false" >
		<div>
			<el-form :model="addruleForm" :rules="rules" ref="adddizhi" label-width="130px" class="demo-ruleForm">
				 <el-form-item label="专票/普通" prop="type">
					<el-radio-group v-model="addruleForm.type">
						<el-radio :label="1">专票</el-radio>
						<el-radio :label="2">普通</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="发票抬头" prop="look">
					<!-- <el-input v-model="addruleForm.look"></el-input> -->
					<el-autocomplete style="width:100%"  class="inline-input" v-model="addruleForm.look" :fetch-suggestions="querySearch" 
					placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="handleSelect" >
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="纳税人识别号" prop="identify_number">
					<el-input v-model="addruleForm.identify_number"></el-input>
				</el-form-item>
				<el-form-item v-if="addruleForm.type==1" label="专票信息" prop="info">
					<el-input type="textarea" v-model="addruleForm.info"></el-input>
				</el-form-item>
				<el-form-item label="设为默认发票" prop="is_default">
					<el-switch v-model="addruleForm.is_default"></el-switch>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button v-preventReClick @click="closeform('')">取 消</el-button>
			<el-button v-preventReClick type="primary" @click="addfap">确 定</el-button>
		</span>
	</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading:true,
				dialogVisible:false,//添加发票
				addruleForm:{
					type:'',//发票类型
					look:'',//发票抬头
					identify_number:'',//纳税人识别号
					info:'',//专票信息
					is_default:0,// 是否是默认发票
					note:'',//备注
				},
				rules:{
					type:{ required: true, message: '请选择发票类型', trigger: 'change' },
					look:{ required: true, message: '请输入发票抬头', trigger: 'blur' },
					identify_number:{ required: true, message: '请输入纳税人识别号', trigger: 'blur' },
					info:{ required: true, message: '请输入专票信息', trigger: 'blur' },
				},
				invoiceList:[],//发票列
				setdizhiCopy:{},//发票信息克隆
				input:'awdhauod',
				radio:true,
				isDisabled:true
			}
		},
		created(){
			this.Postinvoiceget()
		},
		methods: {
			quxiao(i){//修改取消
				this.invoiceList[i] = this.setdizhiCopy;
				this.invoiceList[i].isDisabled = true;
				this.isDisabled=true;
			},
			async Postaddressupdate(item){//修改发票?????
				if(!item.type) this.$message({ message: '请选择发票类型', type: 'warning' });
				else if(!item.look) this.$message({ message: '请输入发票抬头', type: 'warning' });
				else if(!item.identify_number) this.$message({ message: '请输入纳税人识别号', type: 'warning' });
				else if(!item.info && item.type==1) this.$message({ message: '请输入发票抬头', type: 'warning' });
				else{
					if(item.type==2)item.info='';
					delete item.isDisabled
				item.address_id = item.id;
				let {data,code} = await this.api.Postinvoicegetupdate({
					address_id:item.id,
					type:item.type,
					look:item.look,
					identify_number:item.identify_number,
					info:item.info,
					note:item.note,
					is_default:item.is_default
				});
					if(code==200){
						this.$message({ message: '地址修改成功', type: 'success' });
						this.Postinvoiceget();
						this.isDisabled=true;
					}
				}
			},
			async Postaddressdel(address_id){//删除发票
				this.loading = true;
				let {data,code} = await this.api.Postinvoicegetdel({address_id});
				if(code==200) this.$message({ showClose: true, message: '地址删除成功', type: 'success' });
				this.Postinvoiceget();
			},
			async Postaddresssetdefault(address_id){//设为默认地址
				this.loading = true;
				let {code} = await this.api.Postinvoicegetsetdefault({address_id});
				this.Postinvoiceget();
			},
			setDizhi(item){//修改地按下
				item.isDisabled = false;
				this.isDisabled = false;
				this.setdizhiCopy = Object.assign({}, item);
			},
			addfap(){//添加发票
				this.$refs.adddizhi.validate(async (valid) => {
					if (!valid) return;
					let addruleForm = this.addruleForm;
					if(addruleForm.type==2)addruleForm.info='';
					addruleForm.is_default = addruleForm.is_default?1:0;
					this.loading = true;
					let {code} = await this.api.Postinvoiceadd(addruleForm);
					if(code==200){
						this.$message({ message: '发票信息添加成功', type: 'success' });
						this.closeform('');
						this.Postinvoiceget();
					}else this.loading = false;
				});
			},
			async Postinvoiceget(){//获取发票列
				this.loading = true;
				let {data} = await this.api.Postinvoiceget();
				data.data.forEach(v=>{
					// v.addrid = [v.province_id,v.city_id,v.area_id];
					v.isDisabled = true;
				})
				this.invoiceList = data.data;
				this.loading = false;
			},
			closeform(done) {//关闭添加地址
				this.$refs.adddizhi.resetFields();
				if(done) done();
				this.dialogVisible = false;
			},
			async querySearch(queryString, cb) {//发票抬头搜索
				let {data} = await this.api.Postlook({title:queryString});
				cb(data);
			},
			handleSelect(e){//添加选择发票
				this.addruleForm.identify_number = e.taxpayer_number;
				this.addruleForm.look = e.name;
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.laing_btn{
		width: 160px;
		height: 30px;
		line-height: 30px;
	}
	.site_zi {
		margin-bottom: 40px;
		&:hover .flo_right{
		display: block;
	}
		.site_title {
			font-size: 24px;
			color: #333;

			.lan {
				color: var(--themeColor);
				margin-left: 60px;
			}
		}

		.site_form {
			margin: 20px 0;

			.form_left {
				width: 210px;
				float: left;
				height: 30px;
				line-height: 30px;
				color: #333333;
			}

			.che {
				float: left;
				color: #666;
				line-height: 21px;

				input {
					height: 16px;
					width: 16px;
					margin-bottom: 0;
				}

				margin-right: 50px;
			}

			.form_right {
				float: left;
				color: #666;
				width: 280px;
				/deep/ .el-cascader{
					width: 100%;
				}
				input {
					color: #666;
					height: 30px;
					border: 1px solid #D9D9D9;
					width: 280px;
				}

				.form_select {
					width: 110px;
					margin-left: 10px;
				}
				.textarea{
					border: 1px solid #D9D9D9;
				}
				select {
					color: #666;
					box-sizing: content-box;
					height: 34px;
					border: 1px solid #D9D9D9;
					width: 286px;
				}
			}
		}
	}
</style>
